import { render, staticRenderFns } from "./modal_modify_subjec.vue?vue&type=template&id=ff5d3956&scoped=true"
import script from "./modal_modify_subjec.vue?vue&type=script&lang=js"
export * from "./modal_modify_subjec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5d3956",
  null
  
)

export default component.exports